import React from "react";
import {
  CreateBase,
  SimpleForm,
  TextInput,
  SelectInput,
  useNotify,
  useRedirect,
  useCreate,
  required,
} from "react-admin";
import Box from "@mui/material/Box";

const typeChoices = [
  { id: 'FinishedGood', name: 'FinishedGood' },
  { id: 'RawMaterial', name: 'RawMaterial' },
  { id: 'PackagingMaterial', name: 'PackagingMaterial' },
];

const MaterialCreate: React.FC = () => {
  const notify = useNotify();
  const redirect = useRedirect();
  const [create] = useCreate();

  const handleSave = async (data: any) => {
    try {
      await create('materials', { data });
      notify('Save Successfully', { type: 'info' });
      redirect('list', 'materials');
    } catch (error) {
      notify('Save Fail', { type: 'error' });
    }
  };

  return (
    <CreateBase resource="materials">
      <SimpleForm sx={{ backgroundColor: '#ffffff', padding: '36px' }} onSubmit={handleSave}>
        <Box display="flex" flexWrap="wrap" gap={2}>
          <Box flex="1 1 48%">
            <TextInput source="productId" label="Product ID" fullWidth />
          </Box>
          <Box flex="1 1 48%">
            <TextInput source="name" label="Name" fullWidth />
          </Box>
          <Box flex="1 1 48%">
            <SelectInput
              source="type"
              label="Type"
              choices={typeChoices}
              fullWidth
              validate={[required()]}

            />
          </Box>
          <Box flex="1 1 48%">
            <TextInput sx={{ mt: 1 }} source="unit" label="Unit" fullWidth />
          </Box>
          <Box flex="1 1 48%">
            <TextInput source="size" label="Size" fullWidth />
          </Box>
          {/* <Box flex="1 1 48%">
            <TextInput source="size" label="Size" fullWidth />
          </Box>
          <Box flex="1 1 48%">
            <TextInput source="packType" label="pack type" fullWidth />
          </Box> */}
          <Box flex="1 1 48%">
            <TextInput source="description" fullWidth />
          </Box>
          {/* <Box flex="1 1 48%">
            <TextInput source="supplier" fullWidth />
          </Box> */}
          {/* <Box flex="1 1 48%">
            <TextInput type="number" source="perBlend" fullWidth />
          </Box>
          <Box flex="1 1 48%">
            <TextInput label="proportion(%)" type="number" source="percent2" fullWidth />
          </Box>
          <Box flex="1 1 48%">
            <TextInput label="weight(g)" type="number" source="totalKg2" fullWidth />
          </Box> */}
        </Box>
      </SimpleForm>
    </CreateBase>
  );
};

export default MaterialCreate;
